import React from 'react';
import { TrendingUp, Target, Users, Award, BarChart, Shield, Zap } from 'lucide-react';

const StaffingKPIs = () => {
  const kpis = [
    { icon: TrendingUp, text: 'Faster post-placement ramp time' },
    { icon: Target, text: 'Higher placement success rates' },
    { icon: Users, text: 'Reduced early churn' },
    { icon: Award, text: 'Improved client satisfaction' },
    { icon: BarChart, text: 'More consistent candidate quality' },
    { icon: Shield, text: 'Stronger recruiter credibility' },
    { icon: Zap, text: 'Predictable, repeatable readiness' }
  ];

  const reasons = [
    'Enterprise-ready platform',
    'Fast deployment',
    'High candidate adoption',
    'Client-specific customization',
    'Scales from dozens to thousands of placements',
    'Differentiates your firm in a crowded market'
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* KPIs Section */}
        <div className="mb-20">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
              KPIs Traain Improves
              <br />
              <span className="text-cyan-400">for Staffing Leaders</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {kpis.map((kpi, index) => {
              const Icon = kpi.icon;
              return (
                <div
                  key={index}
                  className="p-6 rounded-xl bg-gradient-to-br from-gray-900/80 to-blue-900/20 border border-cyan-500/30 hover:border-cyan-400/60 hover:shadow-lg hover:shadow-cyan-500/20 transition-all duration-300"
                >
                  <Icon className="w-10 h-10 text-cyan-400 mb-4" />
                  <p className="text-lg text-gray-300">{kpi.text}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Why Choose Section */}
        <div className="bg-gradient-to-br from-gray-900/90 to-blue-900/30 border border-cyan-500/30 rounded-3xl p-8 md:p-12">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
              Why Staffing Firms
              <br />
              <span className="text-cyan-400">Choose Traain</span>
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto mb-8">
            {reasons.map((reason, index) => (
              <div key={index} className="flex items-start gap-3">
                <div className="w-2 h-2 bg-cyan-400 rounded-full mt-2 flex-shrink-0" />
                <span className="text-lg text-gray-300">{reason}</span>
              </div>
            ))}
          </div>

          <div className="text-center">
            <p className="text-xl text-cyan-400 font-semibold italic">
              All aboard the next evolution of staffing enablement.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StaffingKPIs;